import Router from 'vue-router'
import store from '../store'

const Home = r => require.ensure([], () => r(require('../components/Home.vue')), 'Home');
const Appointment = r => require.ensure([], () => r(require('../components/Appointment.vue')), 'Appointment');
/* 查报告单↓ */
const Report = r => require.ensure([], () => r(require('../components/Report/Report.vue')), 'Report');
const AssayReport = r => require.ensure([], () => r(require('../components/Report/ReportComponents/AssayReport.vue')),
  'AssayReport');
const CheckReport = r => require.ensure([], () => r(require('../components/Report/ReportComponents/CheckReport.vue')),
  'CheckReport');
const ReportList = r => require.ensure([], () => r(require('../components/Report/ReportComponents/ReportList.vue')),
  'ReportList');
const AssayDetail = r => require.ensure([], () => r(require('../components/Report/ReportComponents/AssayDetail.vue')),
  'AssayDetail');
const CheckDetail = r => require.ensure([], () => r(require('../components/Report/ReportComponents/CheckDetail.vue')),
  'CheckDetail');
// 登录、信息修改
const Login = r => require.ensure([], () => r(require('../components/Login/Login.vue')), 'Login');
const ChangeInfo = r => require.ensure([], () => r(require('../components/Login/ChangeInfo.vue')), 'ChangeInfo');

//就诊记录
const MedicalRecord = r => require.ensure([], () => r(require('../components/Medical/MedicalRecord.vue')),
  'MedicalRecord');
const OutpatientInfo = r => require.ensure([], () => r(require('../components/Medical/OutpatientInfo.vue')),
  'OutpatientInfo');
const HospitalizationInfo = r => require.ensure([], () => r(require('../components/Medical/HospitalizationInfo.vue')),
  'HospitalizationInfo');
const BillDetailInfo = r => require.ensure([], () => r(require('../components/Medical/BillDetailInfo.vue')),
  'BillDetailInfo');


let routes = [{
    path: '/',
    redirect: '/Home',
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
  {
    path: '/Appointment',
    name: 'Appointment',
    component: Appointment
  },
  //查报告单区域↓
  {
    path: '/Report',
    name: 'Report',
    component: Report
  },
  {
    path: '/AssayReport',
    name: 'AssayReport',
    component: AssayReport
  },
  {
    path: '/CheckReport',
    name: 'CheckReport',
    component: CheckReport
  },
  {
    path: '/ReportList',
    name: 'ReportList',
    component: ReportList
  },
  {
    path: '/AssayDetail',
    name: 'AssayDetail',
    component: AssayDetail
  },
  {
    path: '/CheckDetail',
    name: 'CheckDetail',
    component: CheckDetail
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/ChangeInfo',
    name: 'ChangeInfo',
    component: ChangeInfo
  },
  {
    path: '/MedicalRecord',
    name: 'MedicalRecord',
    component: MedicalRecord
  },
  {
    path: '/OutpatientInfo',
    name: 'OutpatientInfo',
    component: OutpatientInfo
  },
  {
    path: '/HospitalizationInfo',
    name: 'HospitalizationInfo',
    component: HospitalizationInfo
  },
  {
    path: '/BillDetailInfo',
    name: 'BillDetailInfo',
    component: BillDetailInfo
  },

];
const router = new Router({
  routes,
  mode: 'hash',
});

router.beforeEach(async (to, from, next) => {
  if (!store.getters.getEncryptRandom) {
    const nonceStr = generateRandomString(8)
    const res = await common
      .ajax({
        transNO: 'getKey',
        method: 'get',
        params: {
          randomCode: nonceStr
        }
      })
    if (res.data && res.data.key) {
      store.state.encryptRandom = nonceStr
      store.state.encryptKey = res.data.key
    }
  }

  next();
})

const generateRandomString = length => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    result += characters.charAt(randomIndex)
  }
  return result
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js